export default "__VITE_ASSET__DD7WQWFZ__"